import api from '@app/utils/api';
import qs from 'qs';

export const generateAnnualReport = (body) => {
  return api.post(`/executive/annual-reports/generate`, body);
};

export const fetchAnnualReports = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/executive/annual-reports?${qParams}`);
};

export const downloadReportPdf = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/executive/annual-reports/download?${qParams}`);
};

export const submitAnnualReport = (body) => {
  return api.post(`/executive/annual-reports/submit`, body);
};

export const removeAnnualReport = (params) => {
  return api.delete(`/executive/annual-reports/remove/${params.reportId}`);
};

export const fetchReportComments = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/executive/annual-reports/comments?${qParams}`);
};
